export const DEFAULT_REQUEST_ERROR = 'An error has occurred. Please try again later.'
export const PROCESS_BUTTON_APPROVAL_REQUEST_DENIED_MESSAGE = 'This request has been denied.'
export const PROCESS_BUTTON_APPROVAL_REQUEST_NEEDS_INFO_MESSAGE =
  "This request has been marked as 'Needs Info'. Once the Coordinator updates the request it will appear as New in the queue."
export const PROCESS_BUTTON_APPROVAL_REQUEST_APPROVED_MESSAGE = 'This request has been approved.'
export const SEE_SUBMISSION_DEADLINE_MSG = 'See Submission Deadline'
